module.exports = __webpack_public_path__ + "static/media/Learn-Effects-of-Vaping-01.963aea40.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/Learn-Effects-of-Vaping-01.mp3
// module id = 568
// module chunks = 0